module.exports = __webpack_public_path__ + "img/stp.1f545eb9.svg";